import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { withRouter } from 'react-router';

const mapaStateToProps = ( { publish } ) => ( { publish } );

@connect( mapaStateToProps, null )
@withRouter
class Wrapper extends Component {

    render() {
        const { route } = this.props;

        return (
            <Fragment>
                { renderRoutes( route.routes, { ...this.props } ) }
            </Fragment>
        );
    };
};
export default Wrapper;